import { z } from 'zod';

/**
 * A member's gender.
 *
 * It is **data**, never a policy branch (U15): nothing in application code may
 * read this and decide behaviour with an `if`. Anything that legitimately
 * differs by gender — pricing, verification steps, blur defaults, nomination
 * counts — is a **gender-scoped setting** read through
 * `getSetting(key, { gender })`. Gender travels through the code only as the
 * scope argument, an audience filter, or a stored attribute.
 */
export const GENDERS = ['male', 'female'] as const;

export const GenderSchema = z.enum(GENDERS);

export type Gender = (typeof GENDERS)[number];

/** The scope value a gender-scoped setting lookup uses (P3). */
export function genderScopeValue(gender: Gender): string {
  return gender;
}
